import React, { useEffect, useState } from 'react';
import SaveModal from './modal/saveModal';
import '../common/css/mypage.css';
import axios from 'axios';
import Cookies from 'js-cookie';
 
function Mypage() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [data, setData] = useState([]);
    const [userId, setUserId] = useState([]);
    const [userName, setUserName] = useState([]);
    const [userTitle, setUserTitle] = useState([]);
    const [userPhone, setUserPhone] = useState([]);
    const [userEmail, setUserEmail] = useState([]);
    const [userPassword, setUserPassword] = useState([]);
    
    useEffect(async () => {
        const hostname = window.location.hostname;
        let isLocal = null;
        if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

        const getInfo = async () => {
            try {
                const data = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/mypage`,
                    {
                        withCredentials: true,
                    },
                ); 


                setData(data.data);
                setUserId(data.data.userId);
                setUserName(data.data.userName);
                setUserTitle(data.data.userTitle);
                setUserPhone(data.data.userPhone);
                setUserEmail(data.data.userEmail);
                setUserPassword(data.data.userPassword);
            } catch (error) {
                Cookies.remove('isLogin');
                setModalContent(error.response.data.message);
                setModalAction(() => () => (window.location.href = '/login'));
                setSaveStatus(false);
            }
        };

        if (data.length === 0) {
            getInfo();
        }
    }, []);

    const saveInfo = async () => {


        if (userName === '') {
            setModalContent('아이디를 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return false;
        } else if (userPhone === '') {
            setModalContent('휴대폰 번호를 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return false;
        } else if (userEmail === '') {
            setModalContent('이메일을 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return false;
        } else if (userPassword === '') {
            setModalContent('비밀번호를 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return false;
        } else {
            try {
                const data = {
                    id: userId,
                    userName: userName,
                    userTitle: userTitle,
                    userPhone: userPhone,
                    userEmail: userEmail,
                    pw: userPassword,
                };

                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                await axios.post(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/mypage`,
                    data,
                    {
                        withCredentials: true,
                    },
                );

                setModalContent('수정이 완료되었습니다.');
                setModalAction(() => () => window.location.reload());
                setSaveStatus(false);
            } catch (err) {
                console.log(err);
                setModalContent(err.response.data.message);
                setModalAction(() => () => setSaveStatus(true));
                setSaveStatus(false);
            }
        }
    };

    return (
        <div className='bodyContainer'>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>마이페이지</div>
                </div>
            </div>
            <div id='contents'>
                <div className='mypageFromWrap'>
                    <div className='page_hgroup'>
                        <h3 class='title'>마이페이지</h3>
                    </div>
                    <div className='agentCheckWrap'>
                        <h4>내 정보</h4>

                        <table className='mypage-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th>ID</th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='userId'
                                                value={userId}
                                                disabled
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span className='important-value'>*</span>이름
                                    </th>
                                    <td className='input-button'>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='userName'
                                                value={userName}
                                                onChange={(e) => setUserName(e.target.value)}
                                                placeholder='이름'
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>직급</th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='userPosition'
                                                value={userTitle}
                                                onChange={(e) => setUserTitle(e.target.value)}
                                                placeholder='직급'
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th><span className='important-value'>*</span>휴대폰</th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='userPhone'
                                                value={userPhone}
                                                onChange={(e) => setUserPhone(e.target.value)}
                                                placeholder='휴대폰'
                                                maxLength={11}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span className='important-value'>*</span>이메일
                                    </th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='userEmail'
                                                value={userEmail}
                                                onChange={(e) => setUserEmail(e.target.value)}
                                                placeholder='이메일'
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span className='important-value'>*</span>비밀번호
                                    </th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='password'
                                                id='userPw'
                                                value={userPassword}
                                                onChange={(e) => setUserPassword(e.target.value)}
                                                placeholder='비밀번호'
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* 회원 정보 */}
                    <div className='agentInfo'>
                        <h4>대리점 정보</h4>

                        <table className='mypage-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th>대리점명</th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='agentName'
                                                placeholder='대리점명'
                                                value={data.kornName}
                                                disabled
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>사업자 등록 번호</th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='businessNumber'
                                                placeholder='사업자 등록 번호'
                                                value={data.saupNumb}
                                                disabled
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>IATA 코드</th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='iataCode'
                                                placeholder='IATA 코드'
                                                value={data.iataCode}
                                                disabled
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>대표자</th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='agentRep'
                                                placeholder='대표자'
                                                value={data.headName}
                                                disabled
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>전화</th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='agentTel'
                                                placeholder='전화'
                                                value={data.teleNumb}
                                                disabled
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>팩스</th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='agentFax'
                                                placeholder='팩스'
                                                value={data.faxiNumb}
                                                disabled
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>주소</th>
                                    <td>
                                        <div className='table-padding'>
                                            <input
                                                type='text'
                                                id='agentAdress'
                                                placeholder='주소'
                                                value={`${(data.addr1, data.addr2)}`}
                                                disabled
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <span
                                class='authNumberTxt'
                                style={{
                                    width: '540px',
                                    display: 'inline-block',
                                    margin: '10px 0 0 0',
                                }}
                            >
                                *회사 정보 수정이 필요할 경우, 필리핀항공 관리팀(02-2085-8712)로
                                연락주시기 바랍니다.
                            </span>
                        </table>
                    </div>
                    <div className='submitArea'>
                        <input
                            type='button'
                            className='each-button'
                            value={'수정사항 저장'}
                            onClick={() => {
                                saveInfo();
                            }}
                        ></input>
                    </div>
                </div>
            </div>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default Mypage;
